module.exports = __webpack_public_path__ + "img/cloudlinux-light.3ac88cc0.png";